// extracted by mini-css-extract-plugin
export default {"input":"O9-z","button":"P9-z","selected":"Q9-z","unavailable":"R9-z","oos":"S9-z","image":"T9-z","paperCutDisabledOverlay":"U9-z"};